module.exports = __webpack_public_path__ + "img/ranking.270d0bec.png";